import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { LoggingInfo } from '../models/logging-info.model';
import { SessionStorageService } from './session-storage.service';
import { SubscriptionChangeService } from 'src/app/services/subscription-change.service';


export interface ILoggingMessageService {
  debug(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  info(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  warn(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
  error(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string);
}

@Injectable({
  providedIn: 'root'
})
export class LoggingMessageService implements ILoggingMessageService {
  private env: string;
  private appName: string;
  private userEmail: string;
  private userID: number;
  private authUserID: number;
  private traceLoggingEmails: Array<string>;

  get UserEmail(): string {
    if (!this.userEmail) {
      this.userEmail = sessionStorage.getItem(environment.TokenEmail);
    }
    return this.userEmail;
  }

  get IsTraceLoggingUser(): boolean {
    let isTrace = false;
    if (this.traceLoggingEmails) {
      this.traceLoggingEmails.forEach(email => {
        if (email === this.UserEmail) {
          isTrace = true;
        }
      });
    }
    return isTrace;
  }

  constructor(private sessionService: SessionStorageService, private logger: NGXLogger) {
    this.logger.setCustomHttpHeaders(new HttpHeaders({ Accept: environment.LogMedia,  'Content-Type': 'application/json' }));
    this.env = environment.environment;
    this.appName = `${environment.applicationName} ${environment.applicationVersion}`;
    this.traceLoggingEmails = environment.TraceLoggingEmails;
  }

  public debug(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const hospid = this.getHospId();
    const unitid = this.getUnitId();
    const indid = this.getIndicatorId();
    subscriptionID = +this.sessionService.getSubscription();
    availableSubscriptions = this.sessionService.getSubscriptionsAvailable();

    setTimeout(() => {
        this.debugMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
    }, 0);
  }

  public info(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const hospid = this.getHospId();
    const unitid = this.getUnitId();
    const indid = this.getIndicatorId();
    subscriptionID = +this.sessionService.getSubscription();
    availableSubscriptions = this.sessionService.getSubscriptionsAvailable();

    setTimeout(() => {
        this.infoMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
    }, 0);
  }

  public warn(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const hospid = this.getHospId();
    const unitid = this.getUnitId();
    const indid = this.getIndicatorId();
    subscriptionID = +this.sessionService.getSubscription();
    availableSubscriptions = this.sessionService.getSubscriptionsAvailable();

    setTimeout(() => {
        this.warnMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
    }, 0);
  }

  public error(appFileName: string, appMethod: string, subscriptionID: number, availableSubscriptions: string,message: string, ex: string) {
    const hospid = this.getHospId();
    const unitid = this.getUnitId();
    const indid = this.getIndicatorId();
    subscriptionID = +this.sessionService.getSubscription();
    availableSubscriptions = this.sessionService.getSubscriptionsAvailable();

    setTimeout(() => {
        this.errorMessage(appFileName, appMethod, hospid, unitid, indid, subscriptionID, availableSubscriptions, message, ex);
    }, 0);
  }

  private isNumber(n: any) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }

  private getHospId(): number {
    const hosp = this.sessionService.getUserHospitalId();
    const isValid = this.isNumber(hosp);
    return (isValid === true) ? Number(hosp) : 0;
  }

  private getUnitId(): number {
    const unit = this.sessionService.getUnitId();
    const isValid = this.isNumber(unit);
    return (isValid === true) ? Number(unit) : 0;
  }

  private getIndicatorId(): number {
    const ind = this.sessionService.getIndicatorId();
    const isValid = this.isNumber(ind);
    return (isValid === true) ? Number(ind) : 0;
  }

  // Message Logging
  private debugMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.WebServer, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'debug');
    this.logger.debug(li);
  }

  private infoMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.WebServer, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'info');
    this.logger.info(li);
  }

  private warnMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.WebServer, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'warn');
    this.logger.warn(li);
  }

  private errorMessage(appFileName: string, appMethod: string, hospID: number, unitID: number, indID: number, subscriptionID: number, availableSubscriptions: string, message: string, ex: string) {
    const li = new LoggingInfo(this.env, null, this.appName, environment.WebServer, appMethod, this.userID, this.UserEmail, this.authUserID, appFileName, hospID, unitID, indID, subscriptionID, availableSubscriptions, message, ex, 'error');
    this.logger.error(li);
  }

}
